import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createAmericana } from '../api/americanas';
import Breadcrumb from '../components/Breadcrumb';
import 'font-awesome/css/font-awesome.min.css';
import './CreateAmericana.css';

export default function CreateAmericana() {
    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [dateTime, setDateTime] = useState('');
    const [location, setLocation] = useState('');
    const [maxPlayers, setMaxPlayers] = useState('');
    const [notes, setNotes] = useState('');

    const [error, setError] = useState(null);
    const [saving, setSaving] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!name || !dateTime || !maxPlayers) {
            setError('Por favor, completa los campos obligatorios (*).');
            return;
        }

        const maxPlayersValue = Number(maxPlayers);
        if (Number.isNaN(maxPlayersValue) || maxPlayersValue <= 0) {
            setError('El cupo debe ser un número positivo.');
            return;
        }

        setSaving(true);
        try {
            const localDate = new Date(dateTime);
            const iso = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000).toISOString();
            await createAmericana({
                name,
                dateTime: iso,
                location: location || undefined,
                maxPlayers: maxPlayersValue,
                notes: notes || undefined
            });
            navigate('/americanas', { state: { successMessage: 'Americana creada correctamente.' } });
        } catch (err) {
            setError(err?.response?.data?.message || 'Error al crear la americana.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="create-page-wrapper">
            <Breadcrumb dark={false} crumbs={[
                { label: 'Americanas', to: '/americanas' },
                { label: 'Nueva Americana' },
            ]} />

            <div className="create-card">
                <div className="form-header">
                    <h1>Nueva Americana</h1>
                    <p>Configura los detalles del próximo torneo</p>
                </div>

                {error && (
                    <div className="error-banner">
                        <i className="fa fa-exclamation-circle"></i>
                        <span>{error}</span>
                    </div>
                )}

                <form onSubmit={onSubmit} className="create-form">
                    <div className="form-group">
                        <label htmlFor="name">Nombre del Evento *</label>
                        <input
                            id="name"
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            placeholder="Ej: Americana de Verano"
                            required
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="dateTime">Fecha y Hora *</label>
                            <input
                                id="dateTime"
                                type="datetime-local"
                                className="form-control"
                                value={dateTime}
                                onChange={e => setDateTime(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="maxPlayers">Cupo *</label>
                            <input
                                id="maxPlayers"
                                type="number"
                                className="form-control"
                                value={maxPlayers}
                                onChange={e => setMaxPlayers(e.target.value)}
                                placeholder="24"
                                min="4"
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="location">Ubicación</label>
                        <input
                            id="location"
                            type="text"
                            className="form-control"
                            value={location}
                            onChange={e => setLocation(e.target.value)}
                            placeholder="Ej: Club Indoor Padel"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="notes">Notas / Descripción</label>
                        <textarea
                            id="notes"
                            className="form-control"
                            value={notes}
                            onChange={e => setNotes(e.target.value)}
                            placeholder="Información extra para las jugadoras..."
                        />
                    </div>

                    <button type="submit" className="btn-submit" disabled={saving}>
                        {saving ? (
                            <span><i className="fa fa-spinner fa-spin"></i> Creando...</span>
                        ) : (
                            <span><i className="fa fa-check"></i> Crear Evento</span>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
}